import workspaceQuery from 'graphql/queries/sales/SalesOrderLineEventWorkspaceQuery.graphql';

const SalesLineEvent = {
  type: 'SalesLineEvent',
  title: 'Sales Order Line Events',
  workspace: workspaceQuery,
};

export default SalesLineEvent;
